export default __webpack_public_path__ + "static/img_diagram-b5ee2bdb1a7bcb09954532310218e1d9.png";